import axios from "axios";

export function getIntegrationServiceAxios(dataConfig) {
  const api = axios.create({
    baseURL: dataConfig.integration_services_api_url,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${dataConfig.integration_services_api_token}`,
    },
  });

  return api;
}